import firebase from "firebase";


class ArticleService {
  constructor(collectionName) {
    this.collectionName = collectionName;
  }
// getter for retriving document from firestore
  getData = async () => {
    const articleOrder = await firebase.firestore().collection(this.collectionName)
                                            .orderBy("addedTime", "desc");
    try {
      const result = await articleOrder.get();
      return result.docs.map(doc => doc.data());
    }
    catch(error) {
      window.alert('404 error');
    }
  }
  // adder for adding document to firestore
  addData = async (data) => {
     const articlePost = await firebase.firestore().collection(this.collectionName);
     try {
        const response = await articlePost.add(data);
        window.alert('Article Added');
      }
      catch(error){
        window.alert('empty fields', error);
      }

    }
}



export default ArticleService;
